/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ship/frame_ship_frigate': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M3 10.254H2V7.965l1.985-1.141.498.867L3 8.543zM5.737 6.971l-.498-.867 7.524-4.32.498.867zM17.484 1.93L16 1.077l-1.485.853-.498-.867L16-.077l1.982 1.14zM26.262 6.971L18.74 2.65l.498-.867 7.523 4.321zM30 10.254h-1V8.543l-1.482-.852.498-.867L30 7.965zM29 11.69h1v8.621h-1zM28.016 25.178l-.498-.867L29 23.459v-1.711h1v2.289zM19.237 30.217l-.498-.867 7.525-4.32.498.866zM16 32.076l-1.983-1.138.498-.868 1.485.854 1.484-.854.498.868zM12.763 30.218l-7.524-4.32.498-.868 7.524 4.321zM3.985 25.178L2 24.037v-2.289h1v1.711l1.483.852zM2 11.691h1v8.62H2z"/>'
  }
})
